 /** @jsxImportSource @emotion/react */
 import { css} from '@emotion/react';
import React,{useEffect, useState} from 'react'
import {  Form, Input } from 'antd'
import { Select, Space } from 'antd';
import Alert from '../alert'
import axios from '../apiClient';
import moment from 'moment';
import Loader from '../loader';
import { ButtonBase } from '@mui/material';
import jwtDecode from 'jwt-decode';
import { useLocation } from 'react-router-dom';


export default function EditOdds() {
    const [leagues, setLeagues] = useState([]);
    const [matches,setMatches] = useState([])
    const [originalLeagues,setOriginalLeagues] = useState([])
    const [loading,setLoading] = useState(true)
    const [saveOddsLoading,setSaveOddsLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const [matchDate,setMatchDate] = useState("");
    const [matchStatus,setMatchStatus] = useState("");
    const [form] = Form.useForm();
    const location = useLocation();
  

    useEffect(()=>{
      fetchData()
      // console.log("location",location.state)
      const {league,homeTeam,awayTeam,odd,popular,matchId,matchDate,status} = location.state.rowData;

      const formObj ={
        leagueId : league.name_en,
        matches: [],
      }
      odd.map((o)=>{
        const obj = {};
        obj.betType = o.type;
        obj.bodyHandicapGoal = o.hdp.raw[0];
        obj.bodyHandicapTeam = o.home_team_has_hadicap ? 'home_team' : 'away_team';
        obj.bodyOdd = o.hdp.raw[1].slice(1);
        obj.bodyOddSign = o.hdp.raw[1].charAt(0);
        obj.matchId = matchId;
        obj.ouHandicapGoal = o.ou.raw[0];
        obj.ouOdd = o.ou.raw[1].slice(1);
        obj.ouOddSign = o.ou.raw[1].charAt(0);
        obj.periods = o.periods;
        obj.popular = popular == 0 ? false : true;
        obj.maxLimit = o.max_limit_bet_amount;
        formObj.matches.push(obj)
      })
      setMatches([{value: matchId,label: homeTeam.name_en + '-' + awayTeam.name_en}])
      setMatchDate(moment(matchDate).format("DD-MM-YYYY h:mm a"))
      setMatchStatus(status)
      console.log('formObj',formObj)
      form.setFieldsValue(formObj)
    },[])
   
    function handleLeagueSearch(query){
       const arr = originalLeagues.filter(v => v.label.toLowerCase().includes(query.toLowerCase()));
       setLeagues(arr)
    }
    async function fetchData() {
        setLeagues([])
        setOriginalLeagues([])
        setLoading(false)
    }

    async function handleLeagueChange(value){
        setLeagues(originalLeagues)
        const startOfDay = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
        const endOfTmr = moment().add(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        // I have removed pagination logic
        const data = await axios.get(`/info/getMatchByLeagueId?leagueId=${value}&&startDate=${startOfDay}&endDate=${endOfTmr}&matchStatus=NS`)

        if (data.code != 200) {
            setErrorMsg({ code: data.code, msg: data.message })
            setOpenAlert(true)
            setMatches([])
            form.setFieldsValue({match: null});
            return
        }
        form.setFieldsValue({match: null});
        // form.setFieldsValue({'hdp/ou': "Body"});
        const obj = form.getFieldsValue()
        obj.matches = [{}]
        form.setFieldsValue(obj)

        const arr = data.data[0].match.map(v=> { return ({value: v.matchId,label: `${v.homeTeam.name_en}-${v.awayTeam.name_en}`})})
        setMatches(arr)
 
    }
    useEffect(()=>{
      form?.getFieldInstance(['matches', 0, 'matchId'])?.focus()
    },[matches])
    function handleMatchChange (v){
    }
    const handleCloseAlert =()=>{
        setOpenAlert(false)
    }
    const handleSave = async (values) =>{
      
    //   return;
      let msg = ""
      if(!values.leagueId){
        msg = "Select league"
      }else if(values.matches.length == 0){
        msg = "Select at least one match"
      }else{
        for (let index = 0; index < values.matches.length; index++) {
          const v = values.matches[index];
          if(!v.matchId) {msg = `Select Match in ${index+1} card`; break;}
          if(!v.bodyHandicapTeam) {msg = `Select body handicap team in ${index+1} card`; break;}
          // if(!v.bodyHandicapGoal) {msg = `Input body handicap goal in ${index+1} card`  ; break ;}
          if(!v.bodyOdd)  {msg = `Input body odd in ${index+1} card` ; break;}
          // if(!v.ouHandicapGoal) {msg = `Input over/under handicap goal in ${index+1} card`; break;}
          if(!v.ouOdd)  {msg = `Input over/under odd in ${index+1} card`; break;}
        }
      }
      if(msg){
        setErrorMsg({ info: true, msg: msg })
        setOpenAlert(true)
        return
      }
      setSaveOddsLoading(true)
      const {leagueId,matches} = values;
      const token = localStorage.getItem("token");
      const {id: ownerId} = jwtDecode(token);
      const odds = matches.map((v)=>{
          const {matchId,bodyHandicapGoal,bodyHandicapTeam,bodyOdd,bodyOddSign,ouHandicapGoal,ouOdd,ouOddSign,periods,betType,maxLimit} = v
          return ({
          matchId: matchId,
          popular: v?.popular ? 1 : 0,
          hdp: {
              raw: [
                  bodyHandicapGoal,
                  bodyOddSign+bodyOdd
              ],
              converted: `${bodyHandicapGoal}${bodyOddSign+bodyOdd}`,
              home_team_has_hadicap: bodyHandicapTeam == 'home_team' ? true : false,  
          },
          ou: {
              raw: [
                  ouHandicapGoal,
                  ouOddSign+ouOdd
              ],
              converted: `${ouHandicapGoal}${ouOddSign+ouOdd}`,
              home_team_has_hadicap: bodyHandicapTeam == 'home_team' ? true : false,  
          },
          periods: periods,
          betType: betType,
          maxLimitBetAmount: maxLimit,
          createdBy: ownerId
      })})

      const params = {odds}

      const data = await axios.post(`/bet/setOddByMatchId`, params)
      if(data.code == 200) data.message = 'odds edited successfully'

      setErrorMsg({ code: data.code, msg: data.message })
      setOpenAlert(true)
      setSaveOddsLoading(false)
    }
    const onFinish = async (values) => {
      handleSave(values)
    };
    const onFinishFailed = (errorInfo) => {
    };
    

  return (
    <div>
        <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
         <Form
          form={form}
          name="dynamic_form_nest_item"
          style={{
            marginTop: "2rem",
            fontFamily: "inherit",
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          css={css`.ant-form-item-explain-error{font-size: 0.8rem}`}
        >
         <SelectLeagueCard handleLeagueChange={handleLeagueChange} handleLeagueSearch={handleLeagueSearch} leagues={leagues} loading={loading} form={form} />
         <Form.List name="matches">
       {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) =>
          {
            return  (
                <SelectMatchCard key={key} handleMatchChange={handleMatchChange} loading={loading} matches={matches} restField={restField} name={name} remove={remove} form={form} add={add} handleSave={handleSave} matchDate={matchDate} matchStatus={matchStatus}/>
              )
          }
         )}
        {/* <Form.Item>
            <Button type="dashed" 
             style={{backgroundColor: "gray",color: 'white'}}
              onClick={() =>{ 
                add()
         
            }} block icon={<PlusOutlined />}>
              Add Match
            </Button>
          </Form.Item> */}
        </>
         )}
       </Form.List>


     
         <SaveButton loading={saveOddsLoading} form={form} handleSave={handleSave}/>
     </Form>
    </div>
  )
}


const SelectLeagueCard = ({handleLeagueChange,handleLeagueSearch,loading,leagues,form}) =>{

  return (
    <div>
        <Form.Item

          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="leagueId"
          style={{ padding: "0 0.4rem", color: "white" }}
        >
        <Select
            // defaultValue={'Ligue 2'}

            style={{width: "30%"  }}
            onChange={handleLeagueChange}
            filterOption={false}
            onSearch={handleLeagueSearch}
            loading={loading}
            showSearch
            options={leagues}
            placeholder="Select League"
        />

       </Form.Item>
    </div>
  )
}

const SelectMatchCard = ({handleMatchChange,loading,matches,restField,name,remove,add,form,handleSave,matchDate,matchStatus})=>{
    const handicapGoal = ["=",1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50]
    const handicapSigns = ["+","-"]
    const fieldNames = ['matchId','periods','betType','popular','maxLimit','bodyHandicapTeam','bodyHandicapGoal','bodyOddSign','bodyOdd','ouHandicapGoal','ouOddSign','ouOdd']
    const periodsNames = [{value: "first_time",label: "first half"},{value: "second_time",label: "second half"},{value: "full_time",label: "full time"}];

    const handleKeyCode = (keyName,fieldName,fieldIndex) => {

      if(keyName == 'ArrowRight'){
        const index = fieldNames.findIndex((name) => name == fieldName)
        let nextFieldName = fieldNames[index+1]
        if(index == (fieldNames.length - 1)){
          if(fieldIndex == (form.getFieldsValue().matches.length - 1)) return
          fieldIndex = fieldIndex + 1
          nextFieldName = fieldNames[0]
        }
        form.getFieldInstance(['matches', fieldIndex, nextFieldName]).focus()
      }

      if(keyName == 'ArrowLeft'){
        const index = fieldNames.findIndex((name) => name == fieldName)
        let nextFieldName = fieldNames[index - 1]
        if(index == 0){
          if(fieldIndex == 0) return
          fieldIndex = fieldIndex - 1
          nextFieldName = fieldNames[fieldNames.length - 1]
        }
        form.getFieldInstance(['matches', fieldIndex, nextFieldName]).focus()
      }

      if(keyName == "Control"){
        handleSave(form.getFieldsValue())
      }
      if(keyName == "Delete"){
        const obj = {...form.getFieldsValue()}
        const newArr = obj.matches.filter((v,index)=> index != fieldIndex)
        obj.matches = newArr;
        form.setFieldsValue(obj)
   
        form.getFieldInstance(['matches', fieldIndex-1,fieldNames[fieldNames.length - 1] ]).focus()

      }
    }

    return (
        <div css={css
            `padding: 30px 30px 6px 30px;
            margin: 1rem 0;
            border-radius: 1rem;
            box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
        `}>
           <div style={{display: "flex",justifyContent: "end",marginBottom: "1rem",marginLeft: "2rem"}}>
              <h4  style={{marginRight: "3rem",fontWeight: "normal"}}>Match Time: {matchDate}</h4>
              <h4 style={{fontWeight: "normal"}}>Status: {matchStatus}</h4>
          </div>
         <div style={{display: "flex",justifyContent:"space-between",alignItems: "center",padding: "0 0.4rem"}}>
             <div style={{display: 'flex',width: '100%',alignItems: 'center'}}>
                 <Form.Item
                      css={css``}
                      wrapperCol={{ span: 24 }}
                      {...restField}
                      name={[name, 'matchId']}
                      style={{ color: "white",width: "30%" }}

                     >
                    <Select
                        style={{width: "100%" ,margin: 0 }}
                        onChange={handleMatchChange}
                        filterOption={false}
                        loading={loading}
                        showSearch
                        options={matches}
                        placeholder="Select Match"
                        onSelect={()=> form.getFieldInstance(['matches', name, 'periods']).focus()}
                        onKeyDown={(e)=> handleKeyCode(e.key,'matchId',name)}
                    />
                 </Form.Item>
                <Form.Item
                      css={css``}
                      wrapperCol={{ span: 24 }}
                      {...restField}
                      name={[name, 'periods']}
                      style={{ color: "white",width: "20%",marginLeft: "2rem" }}
                      initialValue={'full_time'}
       
                     >
                    <Select
                        style={{width: "100%" ,margin: 0 }}
                        options={periodsNames}
                        placeholder="Select Period"
                        onSelect={()=> form.getFieldInstance(['matches', name, 'betType']).focus()}
                        onKeyDown={(e)=> handleKeyCode(e.key,'periods',name)}
                    />
                 </Form.Item>
                 <Form.Item
                      css={css``}
                      wrapperCol={{ span: 24 }}
                      {...restField}
                      name={[name, 'betType']}
                      style={{ color: "white",width: "20%",marginLeft: "2rem" }}
                      initialValue={'all'}
                     >
                    <Select
                        style={{width: "100%" ,margin: 0 }}
                        options={[{value: "Single",label: "single"},{value: "mix_parlay",label: "Parlay"},{value: "all",label: "All"}]}
                        placeholder="Select Bet Type"
                        onSelect={()=> form.getFieldInstance(['matches', name, 'popular']).focus()}
                        onKeyDown={(e)=> handleKeyCode(e.key,'betType',name)}
                    />
                 </Form.Item>
                 <Form.Item  name={[name, 'popular']} initialValue={false}
                 css={css``}
                 wrapperCol={{ span: 24 }}
                 {...restField}
                 style={{ color: "white",width: "20%",marginLeft: "2rem" }}
                 >
                <Select
                    loading={loading}
                    options={[{value: true,label: "Popular"},{value: false,label: "Unpopular"}]}
                    onSelect={()=> form.getFieldInstance(['matches', name, 'maxLimit']).focus()}
                    onKeyDown={(e)=> handleKeyCode(e.key,'popular',name)}
                />
                </Form.Item>
                <Form.Item  name={[name, 'maxLimit']} initialValue={0}
                 css={css``}
                 wrapperCol={{ span: 24 }}
                 {...restField}
                 style={{ color: "white",width: "20%",marginLeft: "2rem" }}
                 >
                 <Input size="middle" placeholder="max limit" type='number'
                  onKeyDown={(e)=>{
                    handleKeyCode(e.key,'maxLimit',name);
                    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
                  }
                  }
                  onPressEnter={()=> form.getFieldInstance(['matches', name, 'bodyHandicapTeam']).focus()}/>
                </Form.Item>
                
             </div>
             {/* <MinusCircleOutlined  className="dynamic-delete-button" onClick={() => remove(name)}  style={{marginBottom: "24px",fontSize: "20px",color: 'gray'}}/> */}
         </div>
         <div style={{display: "flex"}}>
             {/* <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
              >
                <Select disabled suffixIcon={null} options={[{value: "body",label: "Body"}]} defaultValue={'body'}/>
             </Form.Item> */}
             <Form.Item
                  wrapperCol={{ span: 24 }}
                  name={[name,'bodyHandicapTeam']}
                  style={{ padding: "0 0.4rem", color: "white",flexBasis: "25%" }}
                 >
                <Select
                    onChange={handleMatchChange}
                    filterOption={false}
                    // onSearch={handleLeagueSearch}
                    loading={loading}
                    showSearch
                    options={[{value: 'home_team',label: "Home Team"},{value: 'away_team',label: "Away Team"}]}
                    placeholder="Handicap Team"
                    onKeyDown={(e)=> handleKeyCode(e.key,'bodyHandicapTeam',name)}
                    onSelect={()=> form.getFieldInstance(['matches', name, 'bodyHandicapGoal']).focus()}
                />
             </Form.Item>
             <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name={[name,'bodyHandicapGoal']}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                 >
                {/* <Input onKeyDown={(e)=> handleKeyCode(e.key,'bodyHandicapGoal',name)} size="middle" placeholder="Handicap Goal" onPressEnter={()=> form.getFieldInstance(['matches', name, 'bodyOdd']).focus()}/> */}
                <Select
                    onChange={handleMatchChange}
                    filterOption={true}
                    // onSearch={handleLeagueSearch}
                    loading={loading}
                    showSearch
                    options={handicapGoal.map(g=>{ 
                      let value = g;
                      if(g == "=") value = 0;
                      return {value: value,label: g}
                    })}
                    placeholder="Handicap Goal"
                    onKeyDown={(e)=> handleKeyCode(e.key,'bodyHandicapGoal',name)}
                    onSelect={()=> form.getFieldInstance(['matches', name, 'bodyOddSign']).focus()}
                />
             </Form.Item>
             <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name={[name,'bodyOddSign']}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                  initialValue={'+'}
                 >
                {/* <Input onKeyDown={(e)=> handleKeyCode(e.key,'bodyHandicapGoal',name)} size="middle" placeholder="Handicap Goal" onPressEnter={()=> form.getFieldInstance(['matches', name, 'bodyOdd']).focus()}/> */}
                <Select
                    onChange={handleMatchChange}
                    filterOption={true}
                    // onSearch={handleLeagueSearch}
                    loading={loading}
                    showSearch
                    options={handicapSigns.map(g=>{ 
                      if(g == "=") return {value: '0+',label: g}
                      return {value: g,label: g}
                    })}
                    placeholder="odd sign"
                    onKeyDown={(e)=> handleKeyCode(e.key,'bodyOddSign',name)}
                    onSelect={()=> form.getFieldInstance(['matches', name, 'bodyOdd']).focus()}
                />
             </Form.Item>
             <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name={[name,'bodyOdd']}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                 >
                <Input type='number' onKeyDown={(e)=> {
                  handleKeyCode(e.key,'bodyOdd',name);
                  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
                }
                } 
                size="middle" placeholder="odd" onPressEnter={()=> form.getFieldInstance(['matches', name, 'ouHandicapGoal']).focus()}/>
              
             </Form.Item>
         </div>
         <div style={{display: "flex"}}>
             {/* <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                 >
                <Select options={[{value: "ou",label: "Over/Under"}]} defaultValue={'ou'}/>
             </Form.Item> */}
            
             <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name={[name,'ouHandicapGoal']}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                 >
                {/* <Input onKeyDown={(e)=> handleKeyCode(e.key,'ouHandicapGoal',name)} size="middle" placeholder="Handicap Goal"  onPressEnter={()=> form.getFieldInstance(['matches', name, 'ouOddSign']).focus()}/> */}
                 <Select
                    onChange={handleMatchChange}
                    filterOption={true}
                    // onSearch={handleLeagueSearch}
                    loading={loading}
                    showSearch
                    options={handicapGoal.map(g=>{
                       return {value: g,label: g}
                      }).filter(v => v.value != '=')
                    }
                    placeholder="Handicap Goal"
                    onKeyDown={(e)=> handleKeyCode(e.key,'ouHandicapGoal',name)}
                    onSelect={()=> form.getFieldInstance(['matches', name, 'ouOddSign']).focus()}
                />
             </Form.Item>
             <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name={[name,'ouOddSign']}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                  initialValue={'+'}
                 >
                {/* <Input onKeyDown={(e)=> handleKeyCode(e.key,'bodyHandicapGoal',name)} size="middle" placeholder="Handicap Goal" onPressEnter={()=> form.getFieldInstance(['matches', name, 'bodyOdd']).focus()}/> */}
                <Select
                    onChange={handleMatchChange}
                    filterOption={true}
                    // onSearch={handleLeagueSearch}
                    loading={loading}
                    showSearch
                    options={handicapSigns.map(g=>{ 
                      if(g == "=") return {value: '0+',label: g}
                      return {value: g,label: g}
                    })}
                    placeholder="odd sign"
                    onKeyDown={(e)=> handleKeyCode(e.key,'ouOddSign',name)}
                    onSelect={()=> form.getFieldInstance(['matches', name, 'ouOdd']).focus()}
                />
             </Form.Item>
             <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  name={[name,'ouOdd']}
                  style={{ padding: "0 0.4rem", color: "white" ,flexBasis: "25%"}}
                 >
                <Input size="middle" placeholder="odd" type='number'
                  onKeyDown={(e)=>{
                   handleKeyCode(e.key,'ouOdd',name);
                   ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
                  }
                  }
                  onPressEnter={()=> {
                    add()
   
                    setTimeout(()=>{
                      form.getFieldInstance(['matches', name+1, 'matchId']).focus()
                    },[100])
               
                  }}/>
             </Form.Item>
         </div>

     </div>
    )
}


const SaveButton = ({loading,form,handleSave}) =>{
    return(

     <div
         style={{
         display: "flex",
         justifyContent: "end",
         alignItems: "center",
         padding: "0.6rem 0 0 0",
         marginTop: "1rem",
         }}
     >
            
        <ButtonBase
            onClick={()=>handleSave(form.getFieldsValue())}
            component="button"
            style={{
            color: "black",
            display: "flex",
            backgroundColor: "#408E91",
            padding: "0.6rem 1.8rem",
            borderRadius: "2rem",
            justifyContent: "center",
            alignItems: "center",
            }}
        >
            {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 ,color: 'white'}}>Edit</h4>}
        </ButtonBase>
     </div>
    )
}
